import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ScriptLoaderService {
  async load(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script')
      scriptElement.src = url
      scriptElement.async = true
      scriptElement.addEventListener('load', () => resolve())
      scriptElement.addEventListener('error', () => reject(`Could not load script: ${url}`))
      document.head.append(scriptElement)
    })
  }
}
